import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { formatterDate } from "../../../utils"
import { updateCertDemeterDTO } from "./dataService/dto"
import { GetAllDemeter, setUpdateClientType, setUpdateCodexNote, setUpdateCompanyType, setUpdateDemeterNote, setUpdateEdingDate, setUpdateIdDemeter, setUpdatePrivacyProtocol, setUpdateProcessingType, setUpdateStake, setUpdateStartingDate, setUpdateTerzeParti, setUpdateVisitId, setUpdateYear } from "./slice"

export function GestioneDemeterList() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const bioSuisse = useAppSelector(state => state.bioSuisse)
    const demeter = useAppSelector(state => state.demeter)
    const navigate = useNavigate()

    useEffect(() => {
        if (sessionState.selected.customerId) {
            dispatch(GetAllDemeter({ customerId: sessionState.selected.customerId, page: 0, itemsPerPage: 0 }))
        }
    }, [])

    const handleOnEdit = (certDemeter: updateCertDemeterDTO) => {
        dispatch(setUpdateYear(certDemeter.year))
        dispatch(setUpdateStartingDate(certDemeter.startingDate))
        dispatch(setUpdateEdingDate(certDemeter.endingDate))
        dispatch(setUpdateClientType(certDemeter.operatorType))
        dispatch(setUpdateCompanyType(certDemeter.companyType))
        dispatch(setUpdateStake(certDemeter.rate))
        dispatch(setUpdatePrivacyProtocol(certDemeter.privacyProtocolId))
        dispatch(setUpdateDemeterNote(certDemeter.demeterNote))
        dispatch(setUpdateCodexNote(certDemeter.codexNote))
        dispatch(setUpdateTerzeParti(certDemeter.thirdParty))
        dispatch(setUpdateProcessingType(certDemeter.processingType))
        dispatch(setUpdateVisitId(certDemeter.inspectionVisitId))
        dispatch(setUpdateIdDemeter(certDemeter.id))
        navigate('/editDemeter')
    }


    return (
        <div>
            <div className="w-full p-6">
                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm bg-white">
                    <table id="users-table" className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tl-xl w-[60px]"></th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Inizio</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Fine</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Privacy</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Operatore</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Azienda</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note Demeter</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Note Codex</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(demeter.getAllCertificatesResponse?.data ?? []).length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                        Nessun demeter trovato
                                    </td>
                                </tr>
                            ) : (
                                (demeter.getAllCertificatesResponse?.data ?? []).map((pre, index) =>
                                    <tr
                                        key={index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 w-[60px]">
                                            <div className="flex justify-center items-center">
                                                <button className="cursor-pointer" onClick={() => handleOnEdit(pre)}>
                                                    <EditIcon color='orange' size={20} />
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(pre.startingDate)}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(pre.endingDate)}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">-</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.operatorType || '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{pre.companyType || '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700">{pre.demeterNote || '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700">{pre.codexNote || '-'}</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
                {/* <Pagination
                    numbResults={codexSampleState.getAllCodexSampleResponse?.total || 0}
                    pages={codexSampleState.getAllCodexSampleResponse?.totalPage || 1}
                    currentPage={codexSampleState.getAllCodexSampleFilters.page || 0}
                    setPage={
                        (page) => {
                            dispatch(setGetAllCodexSamplePage(page))
                        }
                    }
                /> */}
            </div>
        </div>
    )
}